import isNil from 'lodash.isnil';
import omitBy from 'lodash.omitby';
import { FormTemplate, FormTemplateSection } from 'data/template/template.types';
import { FilterGroup } from 'data/filterGroup/filterGroup.types';

export function createFilterGroupBasedOnTemplate(
  template: FormTemplate,
): FilterGroup {
  const filterGroup: Partial<FilterGroup> = {
    ...getFieldValuesFromSection(template.main as FormTemplateSection),
  };

  return omitBy(filterGroup, isNil) as unknown as FilterGroup;
}

function getFieldValuesFromSection(
  templateSection: FormTemplateSection,
): Partial<FilterGroup> {
  return Object.entries(templateSection?.fields)
    .filter(([_fieldName, field]) => field.initial != null)
    .reduce((previousValue, [fieldName, field]) => ({
      ...previousValue,
      [fieldName]: field.initial,
    }), {});
}
